import SimpleLightbox from "simplelightbox";

/** Block Gallery */
export function blockGallery() {
   new SimpleLightbox('.gallery__images a', { });
}
